<div class="analysis-cards">
  @for (row of rows; track row.id) {
    <app-document-analysis-company-card
      [row]="row"
      (analyze)="analyze.emit($event)"></app-document-analysis-company-card>
  }
</div>
